// Auto generated by ControleTool.ModelClassGenerator
import { inject } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { Helpers } from '../services/helpers';
import { SchoolClassViewModel } from './schoolclassview-model';
import { SchoolYearViewModel } from './schoolyearview-model';
import { SchoolViewModel } from './schoolview-model';


export class UserEditViewModel {
    id: string = null;
	userName: string = null;
	email: string = null;
	division: string = null;
	phoneNumber: string = null;
	schoolClassId: number | null = null;
	schoolId: number | null = null;
	schoolYearId: number | null = null;
	schoolClass: SchoolClassViewModel = null;
	schoolYear: SchoolYearViewModel = null;
	school: SchoolViewModel = null;
	isActive: boolean = true;
	lastLoginDate: Date | null = null;
	firstLoginDate: Date | null = null;
	fullName: string = null;
	
	constructor(data: any = null) {
        
		if (data) {
			Helpers.mapProperties(data, this);
        }
        ValidationRules
			.ensure('userName').displayName('Gebruikersnaam').required()
			.ensure('email').displayName('E-mail').required()
			.ensure('fullName').displayName('Naam').required()
			.on(this);
	}
}